import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    main: {
      border: 'none',
    },
    row: {
      display: 'grid',
    },
    cell: {
      border: 'none',
      overflow: 'hidden',
      '& > *': {
        fontFamily: 'Source Sans Pro, sans-serif',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      padding: '2rem',
      alignSelf: 'center',
    },
  }),
)
